import "./CustomHooks.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  setLoaderFalse,
  setLoaderTrue,
} from "../../../../../Redux/loaderSlice";
import {
  getBase64FromSource,
  transformBankName,
} from "../../../../../utils/Utils";
import FinancialHealthScoreDetailsPDF from "../FinancialHealthScore/FinancialHealthScoreDetails/FinancialHealthScoreDetailsPDF";
import exportimages from "../../../../../assets/images/exportImages";
import { pdf } from "@react-pdf/renderer";
import { useEffect, useState } from "react";
import { generateSegmentInfluencingData } from "../FinancialHealthScore/FinancialHealthScoreDetails/SegmentInfluencingSection";
import { generateAllSegmentData } from "../FinancialHealthScore/FinancialHealthScoreDetails/AllSegmentsSection";
import {
  useGetInsightsAndRecommendationQuery,
  useQueryStateInsightsAndRecommendation,
} from "../../../../../rtk-query/features/insightsAndRecommendation/insightsAndRecommendationSlice";
import {
  FHS_SEGMENTS,
  FHS_SEGMENTS_ADDITIONAL_REGULARITY,
  PDF_EWI_Image_array,
  SUBSCRIPTION,
} from "../../../../../utils/global";
import { useSubscription } from "../../../../../hooks/useSubscription";
import { PRIVILEGES } from "../../../../../utils/privileges";

const DownloadFHSReportButton = ({ showAPValue }) => {
  const { hasSubscription } = useSubscription();
  const dispatch = useDispatch();
  const orgReducer = useSelector((state) => state.orgReducer);
  const authReducer = useSelector((state) => state.authReducer);
  const [earlyWarningIndicators, setEarlyWarningIndicators] = useState([]);

  const selectedbankMetrics = useSelector(
    (state) => state.infiniteBankPerformanceMetricsReducer,
  );
  let selectedFinancialTrend =
    selectedbankMetrics?.selectedBankMetricData?.financial_health_score;

  const [segmentInfluencingObj, setSegmentInfluencingObj] = useState(null);
  const [allSegments, setAllSegments] = useState(null);
  const [regulatorySegments, setRegulatorySegments] = useState(null);
  const [updatedEWIdata, setUpdatedEWIdata] = useState(null);
  // const [isInsightsAvailable, setIsInsightsAvailable] = useState(false);
  // const [adjustedMetrics, setAdjustedMetrics] = useState({});

  useEffect(() => {
    if (!selectedbankMetrics) return;
    //New code
    const fetchData = async () => {
      const segmentDataRaw =
        selectedbankMetrics?.selectedBankMetricData?.growth_metrics;

      if (segmentDataRaw) {
        const segmentData =
          await generateSegmentInfluencingData(segmentDataRaw);
        setSegmentInfluencingObj(segmentData);
      } else {
        setSegmentInfluencingObj(null);
      }
    };

    const fhs_profitability =
      selectedbankMetrics?.selectedBankMetricData?.profitability;
    const fhs_regularity =
      selectedbankMetrics?.selectedBankMetricData
        ?.additional_regulatory_and_risk_metrics;

    const fetchAllSegmentData = async () => {
      if (fhs_profitability) {
        const allSegmentData = await generateAllSegmentData(
          fhs_profitability,
          FHS_SEGMENTS,
        );
        setAllSegments(allSegmentData);
      } else {
        setAllSegments(null);
      }
    };

    const fetchRegulatoryData = async () => {
      if (fhs_regularity) {
        const allSegmentData = await generateAllSegmentData(
          fhs_regularity,
          FHS_SEGMENTS_ADDITIONAL_REGULARITY,
        );
        setRegulatorySegments(allSegmentData);
      } else {
        setRegulatorySegments(null);
      }
    };

    setEarlyWarningIndicators(
      selectedbankMetrics?.selectedBankMetricData?.early_warning_indicators,
    );

    fetchRegulatoryData();
    fetchAllSegmentData();
    fetchData();
  }, [selectedbankMetrics]);

  useEffect(() => {
    const modifiedEWIdata = async () => {
      if (!earlyWarningIndicators || !Array.isArray(earlyWarningIndicators))
        return;

      try {
        const updatedIndicators = await Promise.all(
          earlyWarningIndicators.map(async (item, index) => {
            try {
              // const iconKey = `EWI_${item.icon_name}`;
              // const iconPath = exportimages?.[iconKey] || exportimages?.defaultIcon;
              const iconPath =
                PDF_EWI_Image_array[index]?.EWI_icon ||
                exportimages?.EWI_Default_img;

              const base64Icon = await getBase64FromSource(iconPath);
              const problem_icon = await getBase64FromSource(
                exportimages?.EWI_problem_pdf_icon,
              );
              const rationale_icon = await getBase64FromSource(
                exportimages?.EWI_Rationale_pdf_icon,
              );
              const reccomendation_icon = await getBase64FromSource(
                exportimages?.EWI_Reccomendation_pdf_icon,
              );
              const short_term_icon = await getBase64FromSource(
                exportimages?.EWI_Short_trem_pdf_icon,
              );
              const mid_term_icon = await getBase64FromSource(
                exportimages?.EWI_Mid_trem_pdf_icon,
              );
              const long_term_icon = await getBase64FromSource(
                exportimages?.EWI_Long_trem_pdf_icon,
              );

              return {
                ...item,
                base64Icon,
                problem_icon,
                rationale_icon,
                reccomendation_icon,
                short_term_icon,
                mid_term_icon,
                long_term_icon,
              };
            } catch (itemError) {
              console.error(
                `Failed to process EWI item '${item.icon_name}':`,
                itemError,
              );
              return { ...item }; // fallback return if one item fails
            }
          }),
        );

        setUpdatedEWIdata(updatedIndicators);
      } catch (err) {
        console.error(
          "Unexpected error in modifiedEWIdata:",
          err.message || err,
        );
      }
    };

    modifiedEWIdata();
  }, [earlyWarningIndicators, exportimages]);


  const downloadPdf = async () => {
    dispatch(setLoaderTrue());

    document.getElementById("fhs-details-page").style.minHeight = "max-content";
    document.getElementById("fhs-details-page").style.height = "auto";

    const orgName = orgReducer?.selectedFI?.org_name || "Bank";
    // transformBankName(orgReducer?.selectedFI?.org_name) || "Bank";
    const forecastData = selectedFinancialTrend?.trend;

    await new Promise((resolve) => setTimeout(resolve, 500));

    // Usage
    const base64Chart = await getBase64FromSource(".graph-container");
    const base64ChartNII = await getBase64FromSource(
      ".net-interest-income-graph",
    );
    const base64Logo = await getBase64FromSource(exportimages.pdf_logo);
    const base64Banner = await getBase64FromSource(
      exportimages.pdf_page_banner,
    );
    const formattedDate = new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    // TODO - Remove this code later
    // const doc = (
    //   <FinancialHealthScoreDetailsPDF
    //     orgName={orgName}
    //     forecastData={forecastData}
    //     base64Chart={base64Chart}
    //     base64ChartNII={base64ChartNII}
    //     base64Logo={base64Logo}
    //     base64Banner={base64Banner}
    //     formattedDate={formattedDate}
    //     segmentInfluencingObjPdf={segmentInfluencingObj}
    //     allSegmentDataObjPdf={allSegments}
    //     regulatorySegmentsDataObjPdf={regulatorySegments}
    //     selectedbankMetrics={selectedbankMetrics}
    //     earlyWarningIndicatorsObjPdf={updatedEWIdata}
    //     showAPValue={showAPValue}
    //   />
    // );

    // const blob = await pdf(doc).toBlob();
    // const blobUrl = URL.createObjectURL(blob);

    // dispatch(setLoaderFalse());

    // // Open in new tab
    // window.open(blobUrl, "_blank");

    //ADD - this is correct download pdf
    try {
      const blob = await pdf(
        <FinancialHealthScoreDetailsPDF
          orgName={orgName}
          forecastData={forecastData}
          base64Chart={base64Chart}
          base64ChartNII={base64ChartNII}
          base64Logo={base64Logo}
          base64Banner={base64Banner}
          formattedDate={formattedDate}
          segmentInfluencingObjPdf={segmentInfluencingObj}
          allSegmentDataObjPdf={allSegments}
          regulatorySegmentsDataObjPdf={regulatorySegments}
          selectedbankMetrics={selectedbankMetrics}
          earlyWarningIndicatorsObjPdf={updatedEWIdata}
          showAPValue={showAPValue}
        />,
      ).toBlob();

      dispatch(setLoaderFalse());

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = `${orgName.replace(/[^a-z0-9]/gi, "_")}_FHS_Report.pdf`; // filename-safe
      document.body.appendChild(a);
      a.click();
      a.remove();

      URL.revokeObjectURL(url);

      // Optional: give a short delay to ensure download finishes
      //setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      console.error("Error generating PDF:", error);
      dispatch(setLoaderFalse());
    }
  };

  return (
    <button
      type="button"
      style={{ marginLeft: "0.923rem" }}
      disabled={!hasSubscription(PRIVILEGES.DASHBOARD_PDF_ACCESS)}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        downloadPdf();
      }}
      className="btn btn-bond btn-EWI"
    >
      <span
        className=" fs-btn-text fw-normal"
        style={{ verticalAlign: "text-bottom" }}
      >
        Download Report
      </span>
    </button>
  );
};

export default DownloadFHSReportButton;
